document.addEventListener('DOMContentLoaded', function () {
    const blogHandle = 'cable-academy'; // We are fetching all blogs from these blogs
    const viewParam = 'new-default';
    const blogMain = document.querySelector('.custom-blog .blog-main');

    const activeFiltersEl = document.getElementById('active-filters');
    const activeFilterTagsEl = document.getElementById('active-filter-tags');
    const activeFilterClearAll = document.getElementById('active-filter-clear-all');

    // Mobile sidebar elements
    const sidebar = document.getElementById('sidebar');
    const overlay = document.getElementById('sidebar-overlay');
    const toggleBtn = document.getElementById('mobile-filter-toggle');
    const closeBtn = document.getElementById('sidebar-close');
    const applyBtn = document.getElementById('sidebar-apply');

    // Active filters state
    let activeFilters = new Set();
    let currentPage = 1;

    // Read filters from URL on page load
    function readFiltersFromURL() {
        const params = new URLSearchParams(window.location.search);
        const tags = params.get('filters');
        const page = parseInt(params.get('page')) || 1;
        if (tags) {
            tags.split(',').forEach((t) => {
                const decoded = decodeURIComponent(t).trim();
                if (decoded) activeFilters.add(decoded);
            });
        }
        currentPage = page;
    }

    // Push current filter state into the browser URL (no reload)
    function syncURL() {
        const params = new URLSearchParams(window.location.search);
        if (activeFilters.size > 0) {
            params.set('filters', [...activeFilters].map(encodeURIComponent).join(','));
        } else {
            params.delete('filters');
        }
        if (currentPage > 1) {
            params.set('page', currentPage);
        } else {
            params.delete('page');
        }
        const newURL = `${window.location.pathname}${params.size ? '?' + params.toString() : ''}`;
        history.pushState({ filters: [...activeFilters], page: currentPage }, '', newURL);
    }

    // Sync checkbox checked states to match activeFilters set
    function syncCheckboxesToState() {
        document.querySelectorAll('.sidebar input[type="checkbox"]').forEach((cb) => {
            const tag = cb.dataset.label || cb.value;
            cb.checked = activeFilters.has(tag);
        });
    }

    // Handle browser back/forward
    window.addEventListener('popstate', (e) => {
        activeFilters.clear();
        if (e.state?.filters) e.state.filters.forEach((t) => activeFilters.add(t));
        currentPage = e.state?.page || 1;
        syncCheckboxesToState();
        renderActiveTags();
        applyFilters(false);
    });

    // Mobile sidebar toggle
    function openSidebar() {
        sidebar.classList.add('open');
        overlay.classList.add('visible');
        document.body.style.overflow = 'hidden';
    }
    function closeSidebar() {
        sidebar.classList.remove('open');
        overlay.classList.remove('visible');
        document.body.style.overflow = '';
    }

    // Event listeners for mobile sidebar
    toggleBtn.addEventListener('click', openSidebar);  // Open sidebar on mobile
    closeBtn.addEventListener('click', closeSidebar);  // Close sidebar when clicking the close button
    overlay.addEventListener('click', closeSidebar);  // Close sidebar when clicking outside
    applyBtn.addEventListener('click', closeSidebar);  // Close sidebar when applying filters
    activeFilterClearAll.addEventListener('click', clearAll);  // Clear all filters when clicking "Clear All" in active filters section

    // Filter group toggle (for mobile)
    document.querySelectorAll('.filter-group-head').forEach((head) => {
        head.addEventListener('click', () => {
            head.closest('.filter-group').classList.toggle('open');
        });
    });

    // Render active filter tags
    function renderActiveTags() {
        activeFilterTagsEl.innerHTML = '';
        if (activeFilters.size === 0) {
            activeFiltersEl.style.display = 'none';
            return;
        }

        activeFiltersEl.style.display = 'flex';
        activeFilters.forEach((tag) => {
            const pill = document.createElement('span');
            pill.className = 'active-filter-tag';
            pill.innerHTML = `${tag} <button aria-label="Remove ${tag}">✕</button>`;
            pill.querySelector('button').addEventListener('click', () => {
                removeFilter(tag);
            });
            activeFilterTagsEl.appendChild(pill);
        });
    }

    // Remove a single filter
    function removeFilter(tag) {
        activeFilters.delete(tag);
        // Uncheck matching checkbox
        const cb = document.querySelector(`.sidebar input[data-label="${tag}"]`);
        if (cb) cb.checked = false;
        currentPage = 1;
        renderActiveTags(); // Update active tags display
        applyFilters(); // Re-fetch articles with new filters
    }

    // Convert tag to URL slug (matches Liquid's default behavior)
    function tagToSlug(tag) {
        return tag.trim().replace(/\s+/g, '-');
    }

    // Build URL for fetching filtered articles
    function buildUrl(tags, page) {
        const base = `/blogs/${blogHandle}`;
        const paged = page > 1 ? `&page=${page}` : '';
        if (tags.length === 0) return `${base}?view=${viewParam}${paged}`;
        const slugs = tags.map(tagToSlug).join('+');
        return `${base}/tagged/${slugs}?view=${viewParam}${paged}`;
    }

    // Set loading state (e.g. dim content and disable interactions)
    function setLoading(on) {
        blogMain.style.opacity = on ? '0.4' : '1';
        blogMain.style.pointerEvents = on ? 'none' : '';
        blogMain.style.transition = 'opacity 0.2s ease';
    }

    // Bind click events to pagination links
    function bindPagination() {
        blogMain.querySelectorAll('.pagination-btn, .pagination-number').forEach((btn) => {
            if (btn.tagName !== 'A') return;
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                const url = new URL(this.href);
                currentPage = parseInt(url.searchParams.get('page')) || 1;
                applyFilters();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
        });
    }

    // Fetch and display filtered articles
    async function applyFilters(pushHistory = true) {
        const tags = [...activeFilters];
        const url = buildUrl(tags, currentPage);
        setLoading(true);

        if (pushHistory) syncURL();

        try {
            const res = await fetch(url);
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const grid = doc.querySelector('.blog-grid');
            const pagination = doc.querySelector('.custom-pagination');

            if (grid && grid.querySelector('.blog-card')) {
                blogMain.innerHTML = grid.outerHTML + (pagination ? pagination.outerHTML : '');
                bindPagination();
            } else {
                const tagList = [...activeFilters].map((t) => `<strong>${t}</strong>`).join(', ');
                blogMain.innerHTML = `
                <div class="blog-no-results">
                <p>No articles found for the combination of ${tagList}.</p>
                <p>Try removing one or more filters to broaden your results.</p>
                </div>
             `;
            }
        } catch (err) {
            console.error('[Blog filter] Fetch failed:', err);
            blogMain.innerHTML = '<p class="blog-no-results">Something went wrong. Please refresh and try again.</p>';
        }

        setLoading(false);
    }

    // Event listeners for filter checkboxes
    document.querySelectorAll('.sidebar input[type="checkbox"]').forEach((cb) => {
        cb.addEventListener('change', () => {
            const tag = cb.dataset.label || cb.value;
            cb.checked ? activeFilters.add(tag) : activeFilters.delete(tag);
            currentPage = 1;
            renderActiveTags();
            applyFilters();
        });
    });

    // Clear all filters
    function clearAll() {
        activeFilters.clear(); // Clear the active filters set
        document.querySelectorAll('.sidebar input[type="checkbox"]').forEach((cb) => (cb.checked = false));  // Uncheck all checkboxes
        currentPage = 1;
        renderActiveTags();  // Update the active filters display
        applyFilters();  // Re-fetch articles without any filters
    }

    // Initial render
    readFiltersFromURL();
    syncCheckboxesToState();
    renderActiveTags();
    applyFilters(false);
});